var map = {
	"./UK.jpg": 3657,
	"./bag-1.jpeg": 4006,
	"./bag-2.jpeg": 3634,
	"./bag-3.jpeg": 4558,
	"./bag-4.jpeg": 295,
	"./bag-5.jpeg": 5771,
	"./gft-1.jpeg": 675,
	"./gft-2.jpeg": 7161,
	"./gft-3.jpeg": 6625,
	"./gft-4.jpeg": 1628,
	"./gft-5.jpeg": 7753,
	"./gr-3.jpeg": 5613,
	"./gr-4.jpeg": 8081,
	"./guj-1.jpeg": 5484,
	"./guj-2.jpeg": 4534,
	"./irri.jpeg": 3476,
	"./irri1.jpeg": 5631,
	"./irri2.jpeg": 5248,
	"./irri3.png": 1406,
	"./krishimela.jpeg": 432,
	"./krishimela1.jpeg": 4443,
	"./krishimela2.jpeg": 2979,
	"./krishimela3.jpeg": 2873,
	"./krishimela4.jpeg": 2434,
	"./krishimela5.jpeg": 8335,
	"./nn0.jpg": 20,
	"./nn1 1.jpeg": 7987,
	"./nn2.jpg": 5824,
	"./nn3.jpeg": 1467,
	"./nn4.jpeg": 3120,
	"./nn6.jpeg": 5168,
	"./nn7.jpeg": 2122,
	"./nn8.jpeg": 3883,
	"./noida-1.jpg": 5009,
	"./noida-2.jpeg": 8343,
	"./palghar.jpg": 7604,
	"./palghar1.jpg": 4618,
	"./palghar2.jpg": 8136,
	"./palghar3.jpeg": 1498,
	"./palgharsir.jpeg": 5011,
	"./sakti-1.jpeg": 6805,
	"./sakti-2.jpeg": 6371,
	"./sakti-3.jpeg": 5855,
	"./sakti-4.jpeg": 6698,
	"./up-1.jpeg": 6086,
	"./up-2.jpeg": 4796,
	"./up-3.jpeg": 1183,
	"./up-4.jpeg": 1769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5777;